// extracted by mini-css-extract-plugin
module.exports = {"suggestions":"suggestions-3puC9","container":"container-2hjkp","text":"text-24HW0","money":"money-e_N7S"};